var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pbrTopicRegionDistChart",staticClass:"pbr-topic-chart-container",staticStyle:{"height":"200px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }